// extracted by mini-css-extract-plugin
export default {"badgeWrapper":"xo-z","badgeLink":"yo-z","category":"zo-z"};